import { type Enum } from '@webapp/infrastructure/types/Enum'

export const SpendingCardRegion = {
  US: 'US',
  UK: 'UK',
  CA: 'CA',
} as const

export type SpendingCardRegionEnum = Enum<typeof SpendingCardRegion>
